import { InfoIcon } from '@/assets/icons'
import React, { useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { TooltipContainer, TooltipIcon, TooltipText } from './Tooltip.styles'
import { iconSizes } from '@/theme/tokens'

interface TooltipProps {
	text: string
	children?: React.ReactNode
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
	const [isVisible, setIsVisible] = useState(false)
	const [coords, setCoords] = useState<{ top: number; left: number } | null>(null)
	const containerRef = useRef<HTMLDivElement>(null)
	const tooltipRef = useRef<HTMLDivElement>(null)

	useLayoutEffect(() => {
		if (!isVisible || !containerRef.current || !tooltipRef.current) return
		const anchor = containerRef.current.getBoundingClientRect()
		const tip = tooltipRef.current.getBoundingClientRect()
		setCoords({
			top: anchor.top - tip.height - 8,
			left: anchor.left + anchor.width / 2 - tip.width / 2,
		})
	}, [isVisible])

	return (
		<TooltipContainer
			ref={containerRef}
			onMouseEnter={() => setIsVisible(true)}
			onMouseLeave={() => {
				setIsVisible(false)
				setCoords(null)
			}}
		>
			{children || (
				<TooltipIcon>
					<InfoIcon sx={{ fontSize: iconSizes.lg }} />
				</TooltipIcon>
			)}
			{isVisible &&
				createPortal(
					<TooltipText
						ref={tooltipRef}
						$top={coords?.top ?? -9999}
						$left={coords?.left ?? -9999}
						$visible={!!coords}
					>
						{text}
					</TooltipText>,
					document.body,
				)}
		</TooltipContainer>
	)
}

export default Tooltip
